<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row mb-4">
            <div class="vx-col md:w-1/5 sm:w-full w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Due Date From</label>
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['due-date-from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Due Date To</label>
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['due-date-to']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Order Item Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="status_list" :reduce="option => option.value" label="name"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Account Handler</label>
              <v-select name="staffs" :closeOnSelect="false" :clearable="false"
                v-model="filters['account-handler-id']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/5 sm:w-full">
               <div class="flex">
                <label class="text-sm opacity-100 text-bold">Delivery Address</label>
                <vx-tooltip class="ml-2" style="margin-bottom: -2px;" :title="'Delivery Address'" :text="'Pick a customer to load their saved delivery addresses, then choose a address to filter by.'" position="top">
                  <feather-icon icon="InfoIcon" svgClasses="h-5 w-5 text-primary cursor-pointer" />
                </vx-tooltip>
               </div>
                <v-select :clearable="true" placeholder="Narrow by customer.." v-model="selectedCustomerId" @search="onSearchCustomer"
                            :options="customer_list" :reduce="option => option.id" label="company_name"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="onChangeCustomer">
                    <template slot="no-options">type to search customer</template>
                </v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-full">
              <label class="text-sm opacity-100 text-bold">&nbsp;</label>
              <v-select class="delivery-address-select w-full" multiple :closeOnSelect="false" :clearable="true"
                            placeholder="Choose site addresses.." v-model="filters['delivery-address']"
                            :options="addresses"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="onChangeDeliveryAddress"
                            :selectable="(option) => !isAddressSelected(option)">
                    <template slot="list-header">
                      <li v-if="addresses.length" class="delivery-address-actions">
                        <vs-button v-if="selectedAddressCount !== addresses.length" @mousedown.native.prevent.stop="onClickSelectAllAddresses" size="small">Select all</vs-button>
                        <vs-button v-if="selectedAddressCount > 0" @mousedown.native.prevent.stop="onClickClearAllAddresses" color="danger" size="small">Clear all</vs-button>
                      </li>
                      <li v-if="addresses.length && selectedAddressCount === addresses.length" class="px-3 py-2 text-sm opacity-75">
                        All addresses selected
                      </li>
                    </template>
                    <template slot="no-options">{{ selectedCustomerId ? 'No addresses found for this customer' : 'No addresses found' }}</template>
              </v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">WO QC Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['work-order-qc-status']"
                         :options="[
                           { label: 'Not Submitted', value: 'Not Submitted to QC' },
                           { label: 'Sample Taken', value: 'Sample Taken By QC' },
                           { label: 'Submitted', value: 'Submitted to QC' },
                           { label: 'Approved', value: 'Approved by QC' },
                           { label: 'Rejected', value: 'Rejected by QC' }
                         ]"
                         label="label" :reduce="option => option.value"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">WO Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['work-order-status']"
                         :options="['Open','Confirmed', 'Paused', 'Cancelled', 'In Progress', 'Stopped', 'Dispatched to Supplier', 'Returned from Supplier' ,'Mix Completed', 'Pack Off In Progress', 'Pack Off Completed']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="onClickClear" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card title="SALES ORDER OUTSTANDING LISTING">
          <template slot="actions">
            <div class="flex">
              <vs-button @click.stop="onClickDownloadSheet" class="mr-4 mb-4" color="primary" type="filled">Download Outstanding Orders List</vs-button>
              <!-- <excel-download :name="'courier-shipment-otif-sheet'" button_label="Download OTIF Report"/> -->
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="order_list"
              @sort="handleSort"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th >SO ITEM STATUS</vs-th>
                <vs-th sort-key="formulation-code">PRODUCT CODE</vs-th>
                <vs-th >DESCRIPTION</vs-th>
                <vs-th >CUSTOMER ACC NUMBER</vs-th>
                <vs-th >CUSTOMER</vs-th>
                <vs-th >SALES ORDER NO</vs-th>
                <vs-th sort-key="created_at" >ENTERED ON</vs-th>
                <vs-th sort-key="due-date">REQUIRED BY DATE</vs-th>
                <vs-th sort-key="shipment-date">SHIP BY DATE</vs-th>
                <vs-th >ORDER QTY (KG)</vs-th>
<!--                <vs-th >PACK SIZE</vs-th>-->
                <vs-th sort-key="pending_dispatch_quantity" >PENDING TO DISPATCH BOOKING (KG)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].item_status">
                    {{ data[indextr].item_status }}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_name">
                    {{ data[indextr].formulation_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].customer_code">
                    {{ data[indextr].customer_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].customer_name">
                    {{ data[indextr].customer_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    {{ data[indextr].product_order_code }}
                  </vs-td>

                  <vs-td :data="data[indextr].created_at">
                    {{ data[indextr].created_at }}
                  </vs-td>

                  <vs-td :data="data[indextr].required_by">
                    {{ data[indextr].required_by }}
                  </vs-td>

                  <vs-td :data="data[indextr].shipment_date">
                    {{ data[indextr].shipment_date }}
                  </vs-td>

                  <vs-td :data="data[indextr].quantity">
                    {{ Number(data[indextr].quantity).toFixed(1) }}
                  </vs-td>

<!--                  <vs-td>-->
<!--                  </vs-td>-->

                  <vs-td>
                    {{ data[indextr].pending_dispatch_booking ? Number(data[indextr].pending_dispatch_booking).toFixed(1)  : '-'}}
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <download-outstanding-sales-order-report-pop-up ref="downloadOutstandingSalesOrderReportPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'
  const ReportingRepository = RepositoryFactory.get('reporting')
  const CustomerRepository = RepositoryFactory.get('customer')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  import DownloadOutstandingSalesOrderReportPopUp
    from "@/components/popups/report/DownloadOutstandingSalesOrderReportPopUp";
  import { mapGetters, mapActions } from 'vuex';



  export default {
    name: 'OutstandingOrderList',
    data () {
      return {
        order_list: [],
        filters: {
          'search': '',
          'due-date-from': '',
          'due-date-to': '',
          'status': '',
          'account-handler-id': '',
          'delivery-address': '',
          'work-order-qc-status': '',
          'work-order-status': '',
        },
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        selectedCustomerId: null,
        customer_list: [],
        addresses: [],
        status_list: [
          { name: 'Submitted', value: 'Submitted' },
          { name: 'Accepted', value: 'Pending' },
          { name: 'In-Manufacturing', value: 'In-Manufacturing' },
          { name: 'In-QC', value: 'In-QC' },
          { name: 'In-Dispatch', value: 'In-Dispatch' },
          { name: 'Dispatched', value: 'Dispatched' },
          { name: 'Customer-Received', value: 'Customer-Received' },
          { name: 'Returned', value: 'Returned' },
          { name: 'Goods-Lost', value: 'Goods-Lost' },
          { name: 'Rejected/Cancelled', value: 'Cancelled' },
        ],
      }
    },
    computed: {
      ...mapGetters(['staffs']),
      selectedAddressCount() {
        const selected = this.filters['delivery-address']
        return Array.isArray(selected) ? selected.length : 0
      }
    },
    async mounted () {
      await this.fetchStaffs()
      await this.loadAddresses()
    },
    components: {
      flatPickr,
      DownloadOutstandingSalesOrderReportPopUp,
      'v-select' : vSelect,
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    methods: {
      ...mapActions(['fetchStaffs']),
      async fetchProjectBrief() {
        this.$vs.loading()
        try {
        const {data} = await ReportingRepository.getOutstandingOrderData(this.page, this.filterQuery, this.perPage, this.sort)
          this.order_list =  data.data
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickDownloadSheet() {
        try {
          await this.$refs.downloadOutstandingSalesOrderReportPopUp.openPopup(
            'outstanding-product-order-items-report',
            this.filters['due-date-from'],
            this.filters['due-date-to'],
            this.filters['search'],
          )
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },

      filterQueryUpdate (){
        this.page = 1
        this.fetchProjectBrief()
      },

      handleChangePage(page) {
        this.page = page;
        this.fetchProjectBrief()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchProjectBrief()
        }
      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      onClickClear() {
        this.filters['due-date-from'] = ''
        this.filters['due-date-to'] = ''
        this.filters['search'] = ''
        this.filters['status'] = ''
        this.filters['account-handler-id'] = ''
        this.filters['delivery-address'] = ''
        this.filters['work-order-qc-status'] = ''
        this.filters['work-order-status'] = ''
        this.selectedCustomerId = null
        this.loadAddresses()
      },
      onSearchCustomer(search, loading) {
        if (search.length) {
          loading(true)
          this.searchCustomer(loading, search, this)
        }
      },
      searchCustomer: _.debounce(async (loading, search, vm) => {
        const { data } = await DropDownRepository.getCustomersList(`filter[search]=${search}`)
        vm.customer_list = data.data
        loading(false)
      }, 350),
      async onChangeCustomer(customerId) {
        this.filters['delivery-address'] = ''
        this.addresses = []
        await this.loadAddresses(customerId)
      },
      isAddressSelected(option) {
        const selected = this.filters['delivery-address']
        return Array.isArray(selected) && selected.includes(option)
      },
      onClickSelectAllAddresses() {
        this.filters['delivery-address'] = this.addresses.slice()
      },
      onClickClearAllAddresses() {
        this.filters['delivery-address'] = ''
      },
      onChangeDeliveryAddress(selected) {
        // an empty array still sends `filter[delivery-address]=`, which the API treats
        // as an unresolvable address and returns no rows for — send nothing instead
        if (Array.isArray(selected) && !selected.length) {
          this.filters['delivery-address'] = ''
        }
      },
      async loadAddresses(customerId = null) {
        try {
          const {data} = (await CustomerRepository.getCustomerDeliveryAddressNames(customerId)).data
          this.addresses = this.mapAddressNames(data)
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      // the endpoint returns site names, which are what the filter matches on
      mapAddressNames(raw) {
        return (raw || [])
          .map(item => typeof item === 'string' ? item : (item && item.name))
          .filter(Boolean)
      },
    },
    watch : {
      page(){
        this.fetchProjectBrief()
      },
      perPage() {
        this.fetchProjectBrief()
      }
    },
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }

  /* vue-select gives the menu 5px top padding, which options peek through
     above the pinned row — remove it and let the row supply its own */
  .delivery-address-select >>> .vs__dropdown-menu {
    padding-top: 0;
  }

  /* an address already chosen drops out of the list, and comes back when deselected.
     hidden rather than removed from :options so vue-select can still resolve the
     selected values back to their labels through :reduce */
  .delivery-address-select >>> .vs__dropdown-option--selected {
    display: none;
  }

  /* pinned to the top of the options list so it stays reachable while scrolling */
  .delivery-address-actions {
    position: sticky;
    top: 0;
    z-index: 2;
    background: inherit;
    padding: 10px 12px 8px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  /* keep each label on one line; buttons keep their natural width rather than
     stretching to fill the row when only one of them is showing */
  .delivery-address-actions .vs-button {
    flex: 0 1 auto;
    min-width: 0;
    white-space: nowrap;
  }

</style>
